import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { DIGITAL_CONFIRM, DIGITAL_CONFIRM_SUCCESS, DIGITAL_CONFIRM_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* digitalConfirm({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/other-gm-prices/send-for-approval`,
      method: 'POST',
      data: payload.data,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: DIGITAL_CONFIRM_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: DIGITAL_CONFIRM_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DIGITAL_CONFIRM_ERROR, payload: error });
  }
}

export function* watchDigitalConfirm() {
  yield takeEvery(DIGITAL_CONFIRM, digitalConfirm);
}

function* digitalConfirmSaga() {
  yield all([fork(watchDigitalConfirm)]);
}

export default digitalConfirmSaga;
